import React from 'react';
import { useSelector } from 'react-redux';
import { ErrorBoundary, MetaHeaderTags } from 'mm-ui-components';
import {
    getCanonicalUrl,
    getFacebookAppId,
    getLogoUrl,
    getFacebookPageId, getFavicon, getSiteName,
    getPageDescription, getPageImage, getPageTitle, getTwitterAccount, getAmpURL,
} from '../../store/config/config.selectors';
import { Article } from '../../store/template/template.state.types';

interface MetaTagsProps {
    articles?: Article[]
}

export const MetaTagsConnected: React.FunctionComponent<MetaTagsProps> = ({ articles = [] }) => {
    const facebookAppId = useSelector(getFacebookAppId);
    const facebookPageId = useSelector(getFacebookPageId);
    const description = useSelector(getPageDescription);
    const siteName = useSelector(getSiteName);
    const canonicalUrl = useSelector(getCanonicalUrl);
    const favicon = useSelector(getFavicon);
    const title = useSelector(getPageTitle);
    const twitterAccount = useSelector(getTwitterAccount);
    const pageImage = useSelector(getPageImage);
    const logoUrl = useSelector(getLogoUrl);
    const ampURL = useSelector(getAmpURL);
    return <MetaHeaderTags {...{ facebookAppId, facebookPageId, description, siteName, canonicalUrl, favicon, title, twitterAccount, pageImage, logoUrl, ampURL, articles }} />;
};
export const MetaTags = ({ articles }:MetaTagsProps) => <ErrorBoundary><MetaTagsConnected articles={articles} /></ErrorBoundary>;
